import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import Table from '../../components/Table';
import moment from 'moment';
import { useSelector } from 'react-redux';
import BrazilMoney from 'utils/BrazilMoney';

function BankAccounts() {
  const [bankAccount, setBankAccount] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const nameProperty = useSelector((state) => state.nameProperty.nameProperty);

  const columns = [
    {
      title: 'Descrição',
      field: 'name',
      hideFilterIcon: true,
    },
    {
      title: 'Banco',
      field: 'bank',
      editable: 'never',
      hideFilterIcon: true,
      render: (rowData) => (rowData.bank !== null ? rowData.bank : '-'),
    },
    {
      title: 'Agência',
      field: 'agency',
      editable: 'never',
      hideFilterIcon: true,
      render: (rowData) => (rowData.agency !== null ? rowData.agency : '-'),
    },
    {
      title: 'Número',
      field: 'accountNumber',
      hideFilterIcon: true,
      render: (rowData) => (rowData.accountNumber !== null ? rowData.accountNumber : '-'),
    },
    {
      title: 'Tipo',
      field: 'type',
      editable: 'never',
      hideFilterIcon: true,
      render: (rowData) => rowData.type,
    },
    {
      title: 'Saldo',
      field: 'value',
      editable: 'never',
      hideFilterIcon: true,
      render: (rowData) => <BrazilMoney value={rowData.value} />,
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get('/bank-account');
        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          const data = await response.data;
          const organizedData = await data.map((_element) => ({
            value: BrazilMoney({ value: _element.value }),
            type: _element.type,
            accountNumber: _element.accountNumber,
            agency: _element.agency,
            bank: _element.bank,
            name: _element.name,
          }));

          setBankAccount(data);
          setExportData(organizedData);
          setOpenProgress(true);
        }
      } catch (err) {

      }
    }
    loadData();
  }, [nameProperty]);

  function setData(newData) {
    const tempData = [];
    bankAccount.map((bankAccount) => (bankAccount.id === newData.id
      ? tempData.push(newData)
      : tempData.push(bankAccount)));
    setBankAccount(tempData);
  }

  return (
    <Table
      copy={false}
      title="Controle de Contas"
      route="/bank-accounts/"
      routeAdd="/bank-account/"
      columns={columns}
      data={bankAccount}
      setData={setData}
      dataLoaded={openProgress}
      exportData={exportData}
    />
  );
}

export default BankAccounts;
